import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { _api_get_model } from "../api";
import {
    _formatJsonTemplateToFuiPanels,
    onCheckChildList,
    onCheckParentList,
} from "../utils";
import {
    onCloseModal,
    onConfirmModal,
    onOpenModal,
} from "../utils/dialog.templates";
import { _api_post_task_definition } from "../../../api/offboarding";
import { useSetTasksLocally } from "./useStoreTasksLocally";
import { useUserOffboarding } from "./useUserOffboarding";

const useLogicTasksTemplates = () => {
    const { t } = useTranslation("translation");

    // * STATES
    // * STATES
    // * STATES
    const [stateTemplates, setStateTemplates] = useState([]); // tous les modeles de taches.
    const [stateDialogTemplate, setStateDialogTemplate] = useState(false); // open/close dialog modele de tache

    const { user_offboarding: default_related_to } = useUserOffboarding();

    // * STORE
    // * STORE
    // * STORE
    const setTasksLocally = useSetTasksLocally();

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { isLoading, isFetching } = useQuery(
        "getTemplates",
        () => {
            return _api_get_model();
        },
        {
            refetchOnWindowFocus: true,
            onSuccess: (data) => {
                setStateTemplates(data);
            },
        }
    );
    // modele de tache, appliquer
    const {
        data: taskDefinition,
        isLoading: is_loading_task_definition,
        mutate: mutateTaskDefinition,
    } = useMutation(
        (data) => {
            return _api_post_task_definition(data);
        },
        {
            onSuccess: (data) => {
                const formated_tasks = data.map((task) => {
                    return {
                        document_action: task.document_action,
                        saved_files: task.documents_template,
                        documents_template: task.documents_template,
                        category: task.category_id,
                        id: task.id,
                        document_required: task.document_required,
                        assigned_to: {
                            key: task.assigned_to_user?.id,
                            id: task.assigned_to_user?.id,
                            header: task.assigned_to_user?.name,
                            email: task.assigned_to_user?.email,
                            image: task.assigned_to_user?.avatar,
                            content: task.assigned_to_user?.desc,
                            selected: true,
                        },
                        related_to: default_related_to,
                        name: task?.name,
                        description: task?.description,
                        due_date: task?.due_date,
                        task_to_validate: task?.task_to_validate,
                        who_validate: {
                            id: task.validator?.id,
                            key: task.validator?.id,
                            header: task.validator?.name,
                            email: task.validator?.email,
                            image: task.validator?.avatar,
                            content: task.validator?.desc,
                        },
                        type: task?.type,
                    };
                });
                setTasksLocally(formated_tasks);
                onCloseModal({ setStateDialogTemplate });
                return;
            },
        }
    );

    // * CALL FUNCTIONS
    const formatedTemplatesJson = _formatJsonTemplateToFuiPanels({
        stateTemplates,
        setStateTemplates,
        onCheckParentList,
        onCheckChildList,
    });

    return {
        t,
        query: {
            isLoading: isLoading || isFetching,
            formatedTemplatesJson,
        },
        mutation_task_definition: {
            data: taskDefinition,
            isLoading: is_loading_task_definition,
            mutate: mutateTaskDefinition,
        },
        dialog: {
            open: stateDialogTemplate,
            onCloseModal: () => onCloseModal({ setStateDialogTemplate }),
            onConfirmModal: (e) => {
                e.preventDefault();
                e.stopPropagation();
                // formater les ids des taches selected!
                const ids = stateTemplates
                    .map((template) => template.tasks)
                    .flat()
                    .filter((task) => task.checked)
                    .map((task) => task.id);

                mutateTaskDefinition({
                    id_user: default_related_to.id,
                    ids,
                });
            },
            onOpenModal: () => onOpenModal({ setStateDialogTemplate }),
        },
    };
};

export default useLogicTasksTemplates;
